
  
import React, { Component } from "react";
import { Grid, Cell } from "react-mdl";
import Education from "./education";
import Experience from "./experience";
import Skills from "./skills";
import FadeIn from "react-fade-in";
import ProfilePic from "./images/profile.png"

class Resume extends Component {
  render() {
    return (
      <div>
          
        <Grid>
          <Cell col={4}>
              <FadeIn>
       
            <div style={{ textAlign: "center" }}>
              <img
              className="avatar-resume"
                src={ProfilePic}
                alt="avatar-resume"
                style={{ height: "250px" }}
              />
            </div>

            <h2 style={{ paddingTop: "2em" }}>Max Clayton</h2>
            <h4 style={{ color: "grey" }}>Programmer</h4>
            <hr style={{ borderTop: "3px solid #2c5364", width: "50%" }} />
            <p style={{width: "20em"}}>
              I recently got my degree in Web Design and Development from Utah Valley University. {" "}
            </p>
            <hr style={{ borderTop: "3px solid #2c5364", width: "50%" }} />
            <h5>Email</h5>
            <p>maxclayton07@gmail.com</p>
            <h5>Web</h5>
            <p>maxclayton.github.io</p>
            <hr style={{ borderTop: "3px solid #2c5364", width: "50%" }} />
            </FadeIn>
          </Cell>
          <Cell className="resume-right-col" col={8}>
          <FadeIn>
              
            <h2>Education</h2>

            <Education
              startYear={2018}
              endYear={2022}
              schoolName="UVU"
              schoolDescription="Bachelor's Degree - Web Design & Development. Minor in Digital Media"
            />

            <Education
              startYear={2018}
              endYear={"Current Day"}
              schoolName="Udemy"
              schoolDescription="I have completed several Udemy Courses, including The Complete React Developer Course (w/Hooks and Redux), The Web Developer Bootcamp, Python 3: Project-based Python, Algorithms, Data Structures. "
            />
            <hr style={{ bordertop: "3px solid #e22947" }} />
            <h2>Experience</h2>

            <Experience
              startYear={2020}
              endYear={2021}
              jobName="Slingshot WordPress Developer"
              jobDescription="Worked with various client to ensure their custom forms were exactly how they wanted.  Implemented custom JS automation features throughout the company."
            />

            <Experience
              startYear={2021}
              endYear={2022}
              jobName="Utah Valley University Front End Developer"
              jobDescription="Worked with the various colleges to create, design and edit their websites."
            />

            <Experience
              startYear={2022}
              endYear={"Current Day"}
              jobName="DentalQore Front End Developer"
              jobDescription="Create and maintain websites for different clients using WordPress, PHP, Javascript, HTML & CSS"
            />
            <hr style={{ bordertop: "3px solid #2c5364" }} />
                </FadeIn>
                </Cell>
        </Grid>
      </div>
    );
  }
}

export default Resume;


